import { WhmThemeProvider } from "@securitize/reactjs-whm";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HttpTimeoutDialogHost from "../../components/HttpTimeoutDialogHost";
import { I18nContextProvider } from "../../contexts/I18nContext";
import { MixPanelType } from "../../types/CommonTypes";
import MixPanelProvider from "../../contexts/MixPanelContext";
import { ThemeModeProvider } from "../../contexts/ThemeModeContext";

export interface MFEContainerProps {
  language: string;
  MixPanel: MixPanelType;
  children: React.ReactNode;
}

export default function MFEContainer({
  children,
  language,
  MixPanel,
}: MFEContainerProps) {
  const queryProvider = new QueryClient({
    defaultOptions: {
      queries: {
        // We don't want to refetch every time the window is focused
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryProvider}>
      <MixPanelProvider MixPanel={MixPanel}>
        <I18nContextProvider language={language}>
          <WhmThemeProvider>
            <ThemeModeProvider>
              <HttpTimeoutDialogHost />
              {children}
            </ThemeModeProvider>
          </WhmThemeProvider>
        </I18nContextProvider>
      </MixPanelProvider>
    </QueryClientProvider>
  );
}
